/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DiResolutionTestService {

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAwardApiTestDiResolutionRsuAwardService(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/test/di-resolution/rsu-award-service',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAwardApiTestDiResolutionRsuAwardServiceDetailed(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/test/di-resolution/rsu-award-service/detailed',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAwardApiTestDiResolutionCompareServices(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/test/di-resolution/compare-services',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAwardApiTestDiResolutionDiagnosticRsuAwardService(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/test/di-resolution/diagnostic/rsu-award-service',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAwardApiTestDiResolutionCompareAllServices(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/test/di-resolution/compare-all-services',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAwardApiTestDiResolutionCompareAllServicesExcel(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/test/di-resolution/compare-all-services/excel',
        });
    }

}
